export const darkTheme = {
  bg: "#0d0800",
  bgLight: "#000000",
  primary: "#ff8708",
  text_primary: "#F2F3F4",
  text_secondary: "#F2F3F4",
  card: "#171721",
  card_light: "#191924",
  button: "#ff8708",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}